"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flag = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Flag = require("./Flag.styles");
var _getFlags = require("../../utils/getFlags");
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Flag = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var code = _ref.code,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$showCodeLabel = _ref.showCodeLabel,
    showCodeLabel = _ref$showCodeLabel === void 0 ? false : _ref$showCodeLabel,
    labelLeft = _ref.labelLeft,
    grey = _ref.grey;
  var height;
  var width;
  if (typeof size === 'number') {
    height = 0.75 * size;
    width = size;
  } else {
    switch (size) {
      case 'sm':
        width = 14;
        height = 10.5;
        break;
      case 'md':
        width = 20;
        height = 15;
        break;
      case 'lg':
        width = 40;
        height = 30;
        break;
      case 'xl':
        width = 60;
        height = 45;
        break;
      default:
        width = 14;
        height = 10;
    }
  }
  var classes = (0, _Flag.useStyles)({
    width: width,
    height: height
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, showCodeLabel && labelLeft && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _clsx["default"])(classes.codeLabel, grey && classes.grey)
  }, code), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(classes.flagWrapper, grey && classes.grey)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.flag,
    src: (0, _getFlags.getFlag)(code),
    width: size,
    alt: code
  })), showCodeLabel && !labelLeft && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _clsx["default"])(classes.codeLabel && grey && classes.grey)
  }, code));
});
exports.Flag = Flag;